const JobTitlesTableColumns = [
    { id: 'code', labelAr: 'الكود', labelEn: 'Code', width: 90 },
    { id: 'name', labelAr: 'المسمى الوظيفي', labelEn: 'Job Title' },
    { id: 'department_name', labelAr: 'القسم', labelEn: 'Department', width: 160 },
    { id: 'school_name', labelAr: 'المدرسة', labelEn: 'School', width: 160 },
    { id: 'is_active', labelAr: 'الحالة', labelEn: 'Status', width: 100 },
];

export default JobTitlesTableColumns;
